import { render } from "./AccountDeleteConfirm.vue?vue&type=template&id=44c66794"
import script from "./AccountDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./AccountDeleteConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__